import { Fragment } from "preact";
import Center from "../../../components/center";
import Editorial from "../../../components/editorial";
import Head from "../../../components/head";
import Hero from "../../../components/hero";
import Ligature from "../../../components/ligature";
import CandidateBio from "../../../components/candidate-bio";
import { Link } from "preact-router";

const candidate = {
  name: "John Perkins",
  since: 2023,
  email: "John4Klahanie@gmail.com",
  photo: "/images/candidates/john-perkins.jpg",
};

const pageTitle = `${candidate.name} - Klahanie.info`;

const questions = null;

const CandidatePage = () => (
  <Editorial>
    <Head title={pageTitle} />
    <Hero background="/images/backgrounds/forest-path.jpg">
      <h1>
        <span style="font-size: 0.5em; font-weight: 400; display: block; margin-bottom: 0.25em; text-transform: none;">
          Vote for{" "}
        </span>
        <Ligature>{candidate.name}</Ligature>
      </h1>
      <h2 style="font-size: 1.1em; font-weight: 400;">
        <span>Candidate for Klahanie Board of Directors</span>
      </h2>
    </Hero>
    <div>
      <Center>
        <CandidateBio
          img={candidate.photo}
          name={candidate.name}
          since={candidate.since}
          email={candidate.email}
          questions={questions}
        >
          <h2>Personal</h2>
          <p>
            My wife and I moved to Klahanie in June 2023 with our daughter, who
            now attends Beaver Lake Middle School. We purchased our home sight
            unseen, knowing only that the Issaquah School District had an
            excellent reputation. What we found exceeded our expectations. The
            neighbors, the amenities, the sense of community... we say we won
            the lottery. This is home, and I want to help keep it the kind of
            place where families put down roots.
          </p>

          <h2>Professional Background</h2>
          <p>
            I retired from the U.S. Navy in 2023 as a Captain after 25 years as
            a Public Affairs Officer. In that role, I served as the primary
            communications advisor to commanding officers, helping leaders
            understand how their decisions would be perceived by the public,
            media, families, and elected officials. I planned and executed
            communication strategies, managed media relations during
            high-visibility events and crises, oversaw internal communications
            to keep personnel informed, and built relationships with the
            communities surrounding our installations.
          </p>
          <p>
            The Navy can't accomplish its mission without community trust.
            Earning that trust through clear communication, genuine engagement,
            and consistent follow-through was my job. During my career, I worked
            with all levels of government, including the White House, State
            Department, and Department of Defense, as well as NATO and foreign
            governments across Europe, Africa, and Asia.
          </p>
          <p>
            Currently, I serve as a strategic communications advisor for the
            Navy's Maritime Industrial Base Program, supporting the effort to
            revitalize the industrial base and build the Columbia-class
            ballistic missile submarine, the military's top shipbuilding
            priority. In this role, I help coordinate communications across the
            White House, Pentagon, Congress, state governments, and industry
            leaders on complex, long-term planning and national priorities.
          </p>
          <p>
            That experience translates directly to HOA governance. Homeowners
            deserve to understand what the board is doing, why decisions are
            being made, and how those decisions affect their investment and
            their community. Complex topics like reserve funding, facility
            assessments, and long-term planning shouldn't be mysterious. My job
            is to make them accessible.
          </p>

          <h2>Education &amp; Credentials</h2>
          <ul>
            <li>
              M.A., National Security and Strategic Studies, Naval War College
            </li>
            <li>
              M.A., Mass Communications and Media Studies, San Diego State
              University
            </li>
            <li>B.A., Political Science, University of Texas at Austin</li>
            <li>Accredited in Public Relations (APR)</li>
          </ul>

          <h2>Board Service</h2>
          <p>
            I was appointed to the Klahanie Board of Directors in April 2025 to
            fill a vacant seat. Since then, I have:
          </p>
          <ul>
            <li>
              Served as lead for the Communications Committee, improving the
              newsletter and launching the HOA 101 educational series and
              Committee Spotlights
            </li>
            <li>
              Drafted Board Corner blogs, maintenance updates, and community
              announcements
            </li>
            <li>
              Helped establish the Renew Klahanie Committee to evaluate
              facilities and plan for long-term needs
            </li>
            <li>
              Supported the 2025 bylaw amendments restoring homeowner approval
              for major spending and borrowing decisions
            </li>
            <li>
              Advocated for professional facility assessments before major
              capital decisions
            </li>
          </ul>

          <h2>Why I'm Running</h2>
          <p>
            Homeowners voted for transparency, accountability, and fiscal
            responsibility in 2025. I've worked to deliver on that mandate, and
            I'm asking for your support to continue. If elected, I'll keep
            focused on clear communication, responsible financial stewardship,
            and thoughtful long-term planning for our shared community.
          </p>
        </CandidateBio>
      </Center>
    </div>
  </Editorial>
);

export default CandidatePage;
